import {PATTERN_BOUNDS} from './pattern-erasure.js';

// The mask sits inside the layer transform: moving, rotating and resizing an
// edited sticker or stroke keeps every erased region attached to its artwork.
export default function ArtworkErasure({cuts=[],id,children}){
  if(!cuts.length)return children;
  const holes=cuts.map(({x,y,r,rx=r,ry=r})=>`M${x-rx} ${y}a${rx} ${ry} 0 1 0 ${rx*2} 0a${rx} ${ry} 0 1 0 ${-rx*2} 0Z`).join('');
  return <>
    <defs><mask id={id} maskUnits="userSpaceOnUse" maskContentUnits="userSpaceOnUse" {...PATTERN_BOUNDS} style={{maskType:'luminance'}}>
      <rect {...PATTERN_BOUNDS} fill="white"/>
      <path data-artwork-cuts={cuts.length} d={holes} fill="black" fillRule="nonzero"/>
    </mask></defs>
    <g mask={`url(#${id})`}>{children}</g>
  </>;
}
